<template>
	<div>
		<CRow class="mt-5">
			<CCol lg="12">
				<h4 class="mb-4">
					Active dates
				</h4>
			</CCol>
		</CRow>

		<CRow class="mb-5">
			<CCol md="4">
				<BaseInputDate
					v-model="$v.startDateValue.$model"
					:is-valid="!$v.startDateValue.$error"
					:label="labelStartDate"
					invalid-feedback="Start date is required"
					placeholder="Select date"
					@input="handleActiveStartDateChange"
				>
					<template #append-content>
						<CIcon class="cil-calendar" name="cil-calendar" />
					</template>
				</BaseInputDate>
			</CCol>
			<CCol md="2">
				<BaseInputTime
					v-model="$v.startTimeValue.$model"
					:label="labelStartTime"
					:is-valid="!$v.startTimeValue.$error"
					:invalid-feedback="errorStartTime"
				/>
			</CCol>

			<CCol md="4">
				<BaseInputDate
					v-model="endDateValue"
					:disabled="!$v.startDateValue.$model || $v.startDateValue.$invalid"
					:min-date="$v.startDateValue.$model"
					label="End date"
					placeholder="Select date"
					data-test-id="end-date"
				>
					<template #append-content>
						<CIcon class="cil-calendar" name="cil-calendar" />
					</template>
				</BaseInputDate>
			</CCol>
			<CCol md="2">
				<BaseInputTime
					v-model="$v.endTimeValue.$model"
					:disabled="!$v.startDateValue.$model || $v.startDateValue.$invalid || !endDateValue"
					:is-valid="!$v.endTimeValue.$error"
					:invalid-feedback="errorEndTime"
					label="End time"
				/>
			</CCol>
		</CRow>

		<hr>
	</div>
</template>

<script>
import BaseInputDate from '@/components/BaseInputDate.vue';
import BaseInputTime from '@/components/BaseInputTime.vue';

import dayjs from 'dayjs';

import { requiredIf } from 'vuelidate/lib/validators';

export default {
	name: 'OnSiteMessageDate',

	components: {
		BaseInputDate,
		BaseInputTime,
	},

	validations() {
		return {
			startDateValue: {
				required: requiredIf((data) => data.status),
			},
			startTimeValue: {
				required: requiredIf((data) => data.status),
				validTime(time) {
					return time.length === 5;
				},
			},
			endTimeValue: {
				validTime(time) {
					return time.length === 5 || time.length === 0;
				},
			},
		};
	},

	props: {
		status: {
			type: Boolean,
			default: null,
		},
		startDate: {
			type: [Date, String],
			default: null,
		},
		startTime: {
			type: [String, Number],
			default: null,
		},
		endDate: {
			type: [Date, String],
			default: null,
		},
		endTime: {
			type: [String, Number],
			default: null,
		},
	},

	computed: {
		startDateValue: {
			get() {
				return this.startDate;
			},
			set(value) {
				this.$emit('update:startDate', value);
			},
		},

		startTimeValue: {
			get() {
				return this.startTime;
			},
			set(value) {
				this.$emit('update:startTime', value);
			},
		},

		endDateValue: {
			get() {
				return this.endDate;
			},
			set(value) {
				this.$emit('update:endDate', value);
			},
		},

		endTimeValue: {
			get() {
				return this.endTime;
			},
			set(value) {
				this.$emit('update:endTime', value);
			},
		},

		labelStartDate() {
			return this.status ? 'Select date*' : 'Select date';
		},

		labelStartTime() {
			return this.status ? 'Select time*' : 'Select time';
		},

		errorStartTime() {
			if (!this.startTimeValue.required) {
				return 'Required field';
			}

			if (!this.startTimeValue.validTime) {
				return 'Time not valid';
			}

			return null;
		},

		errorEndTime() {
			if (!this.endTimeValue.validTime) {
				return 'Time not valid';
			}

			if (!this.endTimeValue.after) {
				return `Should be after ${this.startTimeValue}`;
			}

			return null;
		},
	},

	methods: {
		handleActiveStartDateChange(value) {
			if (
				!this.endDateValue ||
				dayjs(value).isAfter(dayjs(this.endDateValue))
			) {
				this.endDateValue = value;
			}
		},
	},
};
</script>
